import { useAppSelector } from "../app/hooks";
import { selectBooking } from "../features/booking/bookingSlice";
import UspBar from "./UspBar";
import Button from "./Button";
import { formatDateLong } from "../helpers/date";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { selectHotel } from "../features/hotel/hotelSlice";
import { useDailyPrices } from "../hooks/useDailyPrices";
import { getRangePrice } from "../helpers/dailyPrices";
import { formatCurrency } from "../helpers/currency";

interface ICartProps {
  next: () => void;
}

function Cart({ next }: ICartProps) {
  const booking = useAppSelector(selectBooking);
  const location = useLocation();
  const [title, setTitle] = useState<string>("");
  const {t} = useTranslation();
  const hotel = useAppSelector(selectHotel);
  const dailyPrices = useDailyPrices();
  const fromPrice =
    booking.StartUtc !== null && booking.EndUtc !== null
      ? getRangePrice(
          dailyPrices,
          hotel.HotelCode,
          booking.StartUtc,
          booking.EndUtc,
          hotel.Culture.CurrencyCode,
        )
      : null;

  /**
   * Set title based on route path
   */
  useEffect(() => {
    const path = location.pathname.replace("/", "");
    setTitle(t(`cart.title.${path}`));
  }, [location.pathname]);
  
  return (
    <>
      <UspBar />
      <div className={`w-full bg-white pb-2 px-4 relative `}>
        <div className="relative z-30">
          <div className="text-fluid-base py-4">
            {(booking.EndUtc === null || booking.Error !== null) && (
              <div
                className={`${
                  booking.Error !== null ? "text-red-600" : "text-black"
                }`}
              >
                {booking.StartUtc === null && booking.EndUtc === null && (
                  <>{t("cart.selectArrivalDate")}</>
                )}
                {booking.StartUtc !== null && booking.EndUtc === null && (
                  <>{t("cart.selectDepartureDate")}</>
                )}
                {booking.Error !== null && <>{booking.Error}</>}
              </div>
            )}

            {booking.EndUtc !== null && booking.Error === null && (
              <div className={`flex justify-between items-center`}>
                <div>
                  {` ${booking.NightCount} ${t('scenes.night', {count: booking.NightCount})} `}{" "}
                  <span className={`text-fluid-sm transition-opacity duration-500`}>
                    ({formatDateLong(booking.StartUtc, false)}{" - "}
                    {formatDateLong(booking.EndUtc, false)})
                  </span>
                </div>
                {fromPrice !== null && (
                  <div className="text-right whitespace-nowrap">
                    <span className="text-fluid-sm">{t("cart.priceFrom")}</span>{" "}
                    {formatCurrency(fromPrice, 0)}
                  </div>
                )}
              </div>
            )}
          </div>

          <div>
            <Button
              text={title}
              onClick={() => next()}
              disabled={
                booking.StartUtc === null ||
                booking.EndUtc === null
              }
            />
          </div>
        </div>
      </div>
    </>
  );
}

export default Cart;
